import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackRemoveUserFromWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackRemoveUserFromWishList = (
    parameters: TrackRemoveUserFromWishListParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "remove_user_from_wishlist", ...parameters }, options);
};

export default trackRemoveUserFromWishList;
